(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-academy"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cm-academy-filter'))customElements.define('cm-academy-filter',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const controls=this.querySelector('.cm-academy__filters');controls.hidden=false;controls.addEventListener('click',(event)=>{const button=event.target.closest('button[data-topic]');if(!button)return;controls.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;this.querySelectorAll('[data-category]').forEach(card=>{card.hidden=button.dataset.topic!=='all'&&card.dataset.category!==button.dataset.topic;if(!card.hidden)count++});const status=this.querySelector('[data-status]');status.textContent=count+' '+status.dataset.label;});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-article"]) return;
  try {
    
if (!customElements.get('cm-article-navigation')) {
  customElements.define('cm-article-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const body = this.querySelector('.cm-article__body');
      const nav = this.querySelector('.cm-article__toc');
      const headings = Array.from(body?.querySelectorAll('h2') || []);
      if (!nav || headings.length < 3) return;
      const list = nav.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = 'cm-article-section-' + (index + 1);
          while (document.getElementById(id)) id += '-section';
          heading.id = id;
        }
        heading.tabIndex = -1;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      nav.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-home-reading"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle', (event) => {
  if (event.target instanceof HTMLDetailsElement && event.target.matches('.cm-origin-film') && !event.target.open) {
    event.target.querySelector('video')?.pause();
  }
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-home-reviews"] && !Shopify.designMode) return;
  try {
    
class CorkMartHomeReviews extends HTMLElement {
  #observer;
  connectedCallback() {
    this.#observer?.disconnect();
    const cleanHeading = () => {
      this.querySelectorAll('.jdgm-testimonials-carousel:not(.jdgm-hidden) h2.jdgm-title').forEach(heading => heading.remove());
    };
    cleanHeading();
    this.#observer = new MutationObserver(cleanHeading);
    this.#observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  disconnectedCallback() { this.#observer?.disconnect(); }
}
if (!customElements.get('cm-home-reviews')) customElements.define('cm-home-reviews', CorkMartHomeReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-information-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cm-page-form]').forEach(form => {
    const key = 'cm-page-draft-' + form.dataset.cmPageForm;
    const success = form.querySelector('[data-cm-page-success]');
    if (success) { try { sessionStorage.removeItem(key); } catch {} success.focus(); return; }
    const fields = Array.from(form.querySelectorAll('input:not([type="hidden"]),textarea'));
    try {
      const draft = JSON.parse(sessionStorage.getItem(key));
      if (draft && Date.now() >= draft.created && Date.now() - draft.created < 86400000) {
        fields.forEach(field => { if (!field.value && typeof draft.values?.[field.name] === 'string') field.value = draft.values[field.name]; });
      }
      if (form.dataset.cmPageForm === 'request-a-quote') {
        const incoming = JSON.parse(sessionStorage.getItem('cork-studio-support'));
        const message = form.querySelector('textarea');
        if (incoming && typeof incoming.summary === 'string' && !message.value && Date.now() >= incoming.created && Date.now() - incoming.created < 86400000) message.value = incoming.summary;
      }
    } catch {}
    const save = () => { try { sessionStorage.setItem(key, JSON.stringify({created: Date.now(), values: Object.fromEntries(fields.map(field => [field.name, field.value]))})); } catch {} };
    form.addEventListener('input', save);
    form.addEventListener('submit', save);
    form.querySelector('[role="alert"]')?.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-premium-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cm-engraving-compare')) {
  customElements.define('cm-engraving-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      const range = this.querySelector('input[type="range"]');
      const control = this.querySelector('.cm-compare__control');
      if (!range || !control) return;
      const update = () => this.style.setProperty('--cm-reveal', `${range.value}%`);
      const scene = this.querySelector('.cm-compare__images');
      const move = (event) => {
        const bounds = scene.getBoundingClientRect();
        range.value = Math.round(Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100)));
        update();
      };
      range.addEventListener('input', update);
      scene.addEventListener('dragstart', (event) => event.preventDefault());
      scene.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        scene.setPointerCapture(event.pointerId);
        move(event);
      });
      scene.addEventListener('pointermove', (event) => {
        if (scene.hasPointerCapture(event.pointerId)) move(event);
      });
      scene.addEventListener('pointerup', (event) => {
        if (scene.hasPointerCapture(event.pointerId)) scene.releasePointerCapture(event.pointerId);
      });
      update();
      control.hidden = false;
      this.setAttribute('data-ready', '');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
